import moment from 'moment';


import Grid from '@mui/material/Grid2'
import { Box } from '@mui/material'



export default function InfoPagotic({ data }) {

    if (!data || !data.id) return (<><p>Error al obtener información de Pagotic. Por favor contactarnos.</p></>)

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container rowSpacing={2} columnSpacing={1}>
                <Grid size={{ xs: 12 }} sx={{ textAlign: 'center' }}>
                    <p><b>Info de Pagotic</b></p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>ID:</b> {data.id}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>Estado:</b> {data.estado}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>Inicio:</b> {moment(data.inicio).format('DD-MM-YYYY HH:mm:ss')}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>Ult. Modificación:</b> {moment(data.ultimaActualizacion).format('DD-MM-YYYY HH:mm:ss')}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>Día de Cobranza:</b> {data.diaCobranza}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>Importe:</b> $ {data.abonoImporte}</p>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                    <p><b>Pagos Realizados:</b> {data.pagosRealizados}</p>
                </Grid>
                {
                    data.motivoBaja &&
                    <Grid size={{ xs: 12, md: 4 }} sx={{ textAlign: 'left' }}>
                        <p><b>Motivo Baja:</b> {data.motivoBaja}</p>
                    </Grid>
                }
            </Grid>
        </Box>
    )

}